// Parsing and validation of the Emails page To field (MWA-401).
// Mirrors backend/lambdas/send-email/recipients.mjs, which enforces the same
// rules on the API; keep the two in step.

export const MAX_RECIPIENTS = 10

const EMAIL_PATTERN =
  /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/

export type ParsedRecipients = { ok: true; recipients: string[] } | { ok: false; error: string }

export function isValidEmailAddress(address: string): boolean {
  return address.length <= 254 && EMAIL_PATTERN.test(address)
}

// Splits on commas, semicolons and whitespace, drops duplicates (case-insensitive,
// first spelling wins) and checks every address.
export function parseRecipients(raw: string): ParsedRecipients {
  const seen = new Set<string>()
  const recipients: string[] = []
  for (const token of raw.split(/[\s,;]+/).filter(Boolean)) {
    const key = token.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    recipients.push(token)
  }

  if (recipients.length === 0) {
    return { ok: false, error: 'Please enter an email address' }
  }

  const invalid = recipients.find((address) => !isValidEmailAddress(address))
  if (invalid) {
    return { ok: false, error: `"${invalid}" is not a valid email address` }
  }

  if (recipients.length > MAX_RECIPIENTS) {
    return { ok: false, error: `Send to ${MAX_RECIPIENTS} addresses or fewer` }
  }

  return { ok: true, recipients }
}
